export class EventsHelper {
    public static readonly ONE_DAY = 24 * 60 * 60 * 1000;
}
